// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pageContainer___y3q7\\+{padding:16px 40px}.pageContainer___y3q7\\+ .tableContainer___nHrTv{margin-top:16px;flex-grow:1}\n", "",{"version":3,"sources":["webpack://./src/routes/ManageTenants/routes/TenantGroup/routes/TenantGroupOverride/TenantGroupOverride.css"],"names":[],"mappings":"AAAA,wBAAA,iBAAA,CAII,gDACI,eAAA,CACA,WAAA","sourcesContent":[".pageContainer {\n    padding: 16px 40px;\n}\n\n    .pageContainer .tableContainer {\n        margin-top: 16px;\n        flex-grow: 1;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": "pageContainer___y3q7+",
	"tableContainer": "tableContainer___nHrTv"
};
export default ___CSS_LOADER_EXPORT___;
